module.exports = __webpack_public_path__ + "media/assets/icons/checkbox-checked-03efca5cb9fafb8ccf1f05114c9127bf.svg";